navigation.addEventListener("navigate", (e) => {
  try {
    if (!window.current_user || !window.current_user.id) {
      return;
    }

    const data = {
      app: "nuevo",
      event_type: "page_load",
      params: {
        object: e.destination.url,
      },
      user: {
        am_user_id: window.current_user.id,
        pilot: "op_2019_2020",
      },
      context: {
        roles: window.user_roles,
      },
      env: FYM_TELEMETRY_BACKEND_URL.match(/.*apc-api-(\w+).*/)[1],
      v: 1,
    };
    const req = fetch(FYM_TELEMETRY_BACKEND_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${window.current_user.access_token}`,
      },
      body: JSON.stringify(data),
    });
    req
      .then((response) => {
        if (!response.ok) {
          console.warn(
            "Telemetry request failed",
            response.status,
            response.statusText,
          );
        }
      })
      .catch((e) => {
        console.warn("Telemetry request failed", e);
      });
  } catch (e) {
    console.warn("Error trying to send telemetry request", e);
  }
});

if (!window.bootstrap) {
  window.bootstrap = function () {};
}

import createHistory from "history/createBrowserHistory";
import React from "react";
import Router from "react-router";
import { Provider } from "react-redux";
import { syncHistoryWithStore } from "react-router-redux";
import Modernizr from "vendor/modernizr";
import log from "rawr/utils/log";
import _ from "lodash";
import Logger from "rawr/utils/Logger";
import flag from "./flags";
import { fetchAccount, pathRequiresAuth } from "./utils/auth";
import "rawr/layout/base.scss";

/* log student traffic */
function ga_student_session() {
  log("Student app loading");
  var dimensionValue = "Student";
  window.ga("set", "dimension1", dimensionValue);
}

/* log teacher traffic */
function ga_teacher_session() {
  log("Teacher app loading");
  var dimensionValue = "Teacher";
  window.ga("set", "dimension1", dimensionValue);
  window.ga("set", "dimension4", window.current_user.id); // deprecate this after userId works
  window.ga("set", "userId", window.current_user.id); // Set the user ID using signed-in user_id.
  if (window.current_user.import_id !== null) {
    window.ga("set", "dimension3", window.current_user.import_id);
  }
}

function ga_log_application(pathName, remainingPath) {
  /*
    /n/apinsight#/2788/create
    pathName: /n/apinsight
    remainingPath: /2788/create
    */

  // ga log application
  var pathSplit = pathName.split("/");
  var app = _.last(pathSplit);
  if (app === "pl") {
    window.ga("set", "dimension2", app);
    log("Logging custom dimension pl");
  } else if (app === "apinsight") {
    var subjectId = parseInt(remainingPath.split("/")[1]);
    if (subjectId > 100) {
      // question bank
      window.ga("set", "dimension2", "qb");
      log("Logging custom dimension qb");
    } else {
      // apinsight
      window.ga("set", "dimension2", app);
      log("Logging custom dimension apinsight");
    }
  }
}

export default function bootstrap(routes, extraProps, finalCallback, store) {
  if (window.current_user.username || !pathRequiresAuth()) {
    runRoutes();
  } else {
    fetchAccount(runRoutes);
  }

  function runRoutes() {
    Router.run(routes, function (Handler, s) {
      if (store) {
        const originalHistory = createHistory();
        // Silently fail until we update dependencies
        originalHistory.transitionTo = () => {};
        const history = syncHistoryWithStore(originalHistory, store);
        Object.assign(extraProps, { history, store });
      }
      const handler = <Handler {...extraProps} {...s} />;
      const component = store ? (
        <Provider store={store}>{() => handler}</Provider>
      ) : (
        handler
      );
      const container = document.getElementById("app");
      const callback = () => {
        const leafRoute = _.findLast(s.routes, "name");
        if (leafRoute) {
          log(s.action || "initial", leafRoute.name, s.path);
        } else {
          if (console) {
            console.error("invalid route");
          }
          setTimeout(() => (location.href = "/"));
        }

        if (window.ga) {
          if (window.current_user.is_student) {
            ga_student_session();
          } else if (window.current_user.is_teacher) {
            ga_teacher_session();
          }
          //console.log("Path:" + location.pathname);
          //console.log("Remaining:" + s.path);
          ga_log_application(location.pathname, s.path);

          window.ga("send", "pageview", location.pathname + s.path);
        }
        if (finalCallback) {
          finalCallback(container);
        }
      };

      if (DEBUG) {
        React.render(component, container, callback);
      } else {
        try {
          React.render(component, container, callback);
        } catch (err) {
          log.error(err);
          Logger.captureException(err);
        }
      }
    });
  }
}



/** WEBPACK FOOTER **
 ** core/client/rawr/bootstrapApp.jsx
 **/